<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="12">
            <v-tabs centered>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassMhs', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-bullhorn</v-icon> Pengumuman
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassworkMhs', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-clipboard-check</v-icon> Tugas
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclasspeopleMhs', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-account-multiple</v-icon> Anggota
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassgradeMhs', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-calendar-month</v-icon> Nilai
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassabsenMhs', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-calendar-check</v-icon> Absen
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" md="12" v-if="alertdata.show">
            <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
          </v-col>
          <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
            <v-progress-circular
              :width="3"
              color="red"
              indeterminate>
            </v-progress-circular>
          </v-col>
          <v-col cols="12" md="12">
            <v-card
              flat
              v-if="!loading.detail && detaildata.length > 0">
              <v-card-text>
                <v-row class="black--text">
                  <v-col cols="12" md="4">
                    <h6 class="text-h6">List Pertemuan</h6>
                    <v-divider class="my-1"></v-divider>
                    <v-list class="limit-height-scroll">
                      <v-list-item-group
                        v-model="pertemuanselect"
                        color="primary">
                        <v-list-item
                          @click="reloadPage"
                          class="style-border-btm mb-1">
                          <v-list-item-title class="py-3">
                            <div class="d-flex align-center">
                              <div class="d-inline black--text">
                                <div>
                                  <b>Semua Pertemuan</b>
                                </div>
                                <div class="caption">
                                  Tampilkan semua tugas dan materi
                                </div>
                              </div>
                            </div>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-for="(pert, i) in listpertemuan"
                          :key="i"
                          @click="selectPertemuan(pert, i)"
                          class="style-border-btm mb-1">
                          <v-list-item-title class="py-3">
                            <div class="d-flex align-center">
                              <div class="d-inline black--text">
                                <div>
                                  <b>{{ pert.name_sess }}</b>
                                </div>
                                <div class="caption">
                                  {{ pert.topic_sess }}
                                </div>
                                <div class="caption">
                                  {{ pert.start_sess }}
                                </div>
                                <div class="caption">
                                  <v-chip
                                    x-small
                                    :color="pert.s_sess_type === 'reguler' ? 'primary' : 'warning'">
                                    {{ pert.s_sess_type }}
                                  </v-chip>
                                </div>
                              </div>
                            </div>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-card flat v-if="pertemuandata">
                      <v-app-bar flat color="transparent" dense>
                        <v-toolbar-title class="font-weight-bold primary--text">
                          {{ pertemuandata.name_sess }}
                        </v-toolbar-title>
                      </v-app-bar>
                      <v-card-text class="pt-0">
                        <div class="mb-2">
                          <div class="font-weight-bold black--text">
                            Topic: {{ pertemuandata.topic_sess }}
                          </div>
                          <div class="caption">
                            {{ pertemuandata.start_sess }} - {{ pertemuandata.end_sess }}
                            <v-chip
                              x-small
                              :color="pertemuandata.s_sess_type === 'reguler' ? 'primary' : 'warning'">
                              {{ pertemuandata.s_sess_type }}
                            </v-chip>
                          </div>
                        </div>
                        <div class="d-inline">
                          <div v-if="pertemuandata.s_sess_type === 'tambahan'">
                            <v-btn
                              v-if="!dataabsen.length"
                              color="error"
                              class="text-capitalize"
                              depressed
                              small
                              @click="addAbsen(pertemuandata)">
                              <v-icon left>mdi-calendar-check</v-icon>
                              Absensi
                            </v-btn>
                            <div v-if="dataabsen.length">
                              <v-chip
                                small
                                :color="dataabsen[0].status_absen === 'Hadir' ? 'success' : (dataabsen[0].status_absen === 'Alpa' ? 'error' : 'warning') ">
                                Absensi: {{ dataabsen[0].status_absen }}
                              </v-chip>
                            </div>
                          </div>
                          <div v-if="pertemuandata.s_sess_type === 'reguler'">
                            <v-btn
                              color="warning"
                              class="text-capitalize"
                              depressed
                              small
                              href="https://sion.pnb.ac.id/index.php?page=724"
                              target="_blank">
                              <v-icon left>mdi-calendar-check</v-icon>
                              Absen Melalui SION
                            </v-btn>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                    <h6 v-if="!pertemuandata" class="text-h6">
                      Semua list tugas dan materi
                    </h6>
                    <v-divider class="my-1"></v-divider>
                    <div v-if="postlist.length > 0">
                      <v-expansion-panels flat focusable>
                        <v-expansion-panel
                          v-for="(post, i) in postlist"
                          :key="i">
                          <v-expansion-panel-header hide-actions>
                            <div class="d-flex align-center">
                              <div class="d-inline">
                                <v-btn
                                  outlined
                                  class="mr-2 d-inline"
                                  fab
                                  small
                                  dark
                                  color="primary">
                                  <v-icon>{{ post.type_post === 'materi' ? 'mdi-book' : 'mdi-clipboard-text' }}</v-icon>
                                </v-btn>
                              </div>
                              <div class="d-inline">
                                <div>{{ post.title_post }}</div>
                                <span class="text-right caption font-weight-bold" v-if="post.type_post === 'tugas'">
                                  Due {{ post.duedate_post }}
                                </span>
                                <span class="text-right caption font-weight-bold" v-if="post.type_post === 'materi'">
                                  Posted {{ post.posted_at_post }}
                                </span>
                              </div>
                            </div>
                            <v-spacer></v-spacer>
                            <v-row
                              v-if="false"
                              align="center"
                              justify="end">
                              <span class="text-right ml-2">
                                <v-menu
                                  offset-y
                                  bottom
                                  left
                                  nudge-bottom="10"
                                  transition="scale-transition">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      color="primary"
                                      class="text-capitalize"
                                      icon
                                      v-bind="attrs"
                                      v-on="on"
                                      exact>
                                      <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                  </template>
                                  <v-list>
                                    <v-list-item>
                                      <v-list-item-title>Salin link</v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </span>
                            </v-row>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <div class="pa-1">
                              <div class="content-editor" v-html="post.desc_post"></div>
                            </div>
                            <v-divider class="py-1"></v-divider>
                            <v-btn
                              v-if="post.type_post === 'materi'"
                              color="primary"
                              depressed
                              tile
                              text
                              small
                              class="px-1 text-capitalize"
                              :to="{ name: 'DetailpostmateriMhs', query: { post: post.id_post, class: check.class } }">
                              Lihat materi
                            </v-btn>
                            <v-btn
                              v-if="post.type_post === 'tugas'"
                              color="primary"
                              depressed
                              tile
                              text
                              small
                              class="px-1 text-capitalize"
                              :to="{ name: 'DetailposttugasMhs', query: { post: post.id_post, class: check.class } }">
                              Lihat tugas
                            </v-btn>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                    <div v-if="postlist.length <= 0" class="grey--text text-center">
                      Belum ada materi atau tugas yang diunggah!
                    </div>
                  </v-col>
                  <v-col cols="12" md="12">
                    <div class="mt-5 text-center">
                      <v-btn
                        class="mr-2 mb-2"
                        fab
                        depressed
                        dark
                        x-small
                        :to="{ name: 'ListclassMhs' }">
                        <v-icon dark>
                          mdi-arrow-left-thick
                        </v-icon>
                      </v-btn>
                      <span class="title">Daftar kelas</span>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- add absen -->
    <v-dialog
      v-model="dmodal.addabsen"
      max-width="450px">
      <v-card v-if="dmodaldata.addabsen">
        <v-card-title>
          <span class="text-truncate col-10 px-0">
            Absensi "{{ dmodaldata.addabsen.name_sess }}"
          </span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.addabsen = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-form
            @submit.prevent="submitAddAbsen"
            ref="formaddabsen"
            v-model="formadd.absen"
            lazy-validation>
            <alertsp :alertdata="alertupdate"></alertsp>
            <v-radio-group
              v-model="pilihabsen"
              row
              :rules="[rules.required]">
              <v-radio
                label="Hadir"
                value="Hadir">
              </v-radio>
              <v-radio
                label="Ijin"
                value="Ijin">
              </v-radio>
              <v-radio
                label="Sakit"
                value="Sakit">
              </v-radio>
            </v-radio-group>
            <v-btn
              depressed
              class="my-3 text-capitalize"
              :loading="loading.addabsen"
              :disabled="loading.addabsen || !formadd.absen"
              color="primary"
              type="submit">
              Simpan
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog -->
    <v-dialog
      v-model="dmodal.reuse"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Select post
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('reuse')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="py-5">
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { VueEditor } from 'vue2-editor';
import { mapState } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: 'DetailclassworkMhs',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
      post: false,
      pertemuan: false,
      addtugas: false,
      addmateri: false,
      addabsen: false,
      getabsen: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    detaildata: [],
    postlist: [],
    listpertemuan: [],
    pertemuanselect: 0,
    pertemuandata: null,
    pilihabsen: null,
    dataabsen: [],
    panduan: null,
    addtugas: {
      title_post: '',
      desc_post: '',
      duedate_post: null,
      file_post: null,
    },
    addmateri: {
      title_post: '',
      desc_post: '',
      file_post: null,
    },
    paramclass: {
      search: '',
      limit: '',
      offset: '',
    },
    check: {
      class: '',
    },
    formcheck: {
      valid: false,
    },
    formadd: {
      tugas: false,
      absen: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      files: [
        (value) => !value || value.size < 5000000 || 'Files less than 5 MB!',
      ],
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    dmodal: {
      tugas: false,
      materi: false,
      reuse: false,
      addabsen: false,
    },
    dmodaldata: {
      addabsen: null,
    },
  }),
  watch: {
    '$route.query.class'(val) {
      if (val) {
        this.check.class = val;
        this.getClass();
      }
    },
  },
  mounted() {
    if (this.$route.query.class && this.$route.query.class !== '') {
      this.check.class = this.$route.query.class;
      this.getClass();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    reloadPage() {
      this.$router.go();
    },
    closeDmodal(type) {
      if (type === 'tugas') {
        this.dmodal.tugas = false;
      } else if (type === 'materi') {
        this.dmodal.materi = false;
      } else if (type === 'reuse') {
        this.dmodal.reuse = false;
      } else {
        this.dmodal.tugas = false;
      }
    },
    reusePost() {
      this.dmodal.reuse = true;
    },
    getClass() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.class) {
        this.axios
          .get(
            this.api + '/api/kelas/student/' + this.check.class,
            {
              params: this.paramclass,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                this.getPertemuan();
                this.getPost();
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Kelas tidak ditemukan!';
      }
    },
    getPost() {
      if (this.tokenscr) {
        this.loading.post = true;
        let parampost = {};
        this.postlist = [];
        if (this.pertemuandata) {
          parampost = {
            session: this.pertemuandata.id_session,
          };
        }
        this.axios
          .get(
            this.api + '/api/post/class/' + this.check.class,
            {
              params: parampost,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.postlist = resdata.data;
              }
            }
            this.loading.post = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.post = false;
          });
      }
    },
    getPertemuan() {
      if (this.tokenscr) {
        this.loading.pertemuan = true;
        this.listpertemuan = [];
        this.axios
          .get(
            this.api + '/api/pertemuan/class/' + this.check.class,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.listpertemuan = resdata.data;
              }
            }
            this.loading.pertemuan = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.pertemuan = false;
          });
      }
    },
    selectPertemuan(item, idx) {
      this.pertemuandata = item;
      this.getPost();
      this.getAbsen(item);
      // console.log(item);
      // this.selectidx = idx;
    },
    addAbsen(item) {
      // console.log(item);
      this.alertupdate.show = false;
      this.dmodal.addabsen = true;
      this.dmodaldata.addabsen = JSON.parse(JSON.stringify(item));
    },
    getAbsen(item) {
      if (this.tokenscr) {
        // console.log(item);
        this.loading.getabsen = true;
        this.dataabsen = [];
        this.axios
          .get(
            this.api + '/api/pertemuan/absen/' + item.id_session,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.dataabsen = resdata.data;
                // console.log(this.dataabsen);
              }
            }
            this.loading.getabsen = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getabsen = false;
          });
      }
    },
    submitAddAbsen() {
      this.alertupdate.show = false;
      if (this.$refs.formaddabsen.validate()) {
        if (this.tokenscr) {
          this.loading.addabsen = true;
          const formData = new FormData();
          // file image
          formData.append('status_absen', this.pilihabsen);
          formData.append('id_session', this.pertemuandata.id_session);
          formData.append('id_class', this.check.class);
          // send data
          this.axios
            .post(
              this.api + '/api/pertemuan/absen',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.$refs.formaddabsen.reset();
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Absensi berhasil di simpan!';
                  this.getAbsen(this.pertemuandata);
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.addabsen = false;
            })
            .catch((error) => {
              this.loading.addabsen = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
    VueEditor,
    DatePicker,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
